/** 「すべてのコース」を表す値（SpotFilterRow の ALL_SHEETS_VALUE と同値） */
export const ALL_SHEETS = ''

/**
 * スポット一覧のコース選択に表示する値を決める（#3334）。
 * 1. ユーザーの選択（'' または候補内のシートID）
 * 2. 初期シート（候補内にある場合）
 * 3. すべてのコース
 * 候補が 2 件未満のときは PillSelect が出ず解除できないため、常に「すべて」にする。
 */
export function resolveSelectedSheet(params: {
  userSelection: string | null
  defaultSheetId: number | null
  optionSheetIds: readonly number[]
}): string {
  const { userSelection, defaultSheetId, optionSheetIds } = params
  if (optionSheetIds.length < 2) return ALL_SHEETS

  const isOption = (value: string) => optionSheetIds.some((id) => String(id) === value)

  if (userSelection !== null && (userSelection === ALL_SHEETS || isOption(userSelection))) return userSelection
  if (defaultSheetId !== null && isOption(String(defaultSheetId))) return String(defaultSheetId)
  return ALL_SHEETS
}
